<!-- thank-you section start -->
<section class="section-b-space light-layout" *ngIf="!orderFail && orden">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="success-text">
                    <i class="fa fa-check-circle" aria-hidden="true"></i>
                    <h2>¡GRACIAS!</h2>
                    <p>Tu compra ha sido exitosa, te avisaremos cuando el pedido esté en camino.</p>
                    <p>Número de Orden: {{orden?.numeroOrden}}</p>

                </div>
            </div>
        </div>
    </div>
</section>
<!-- Section ends -->
<!-- thank-you section start -->
<!-- <section class="section-b-space light-layout" *ngIf="orderFail === true">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="success-text">
                    <i class="fa fa-times-circle" aria-hidden="true" style="color: red !important; height: 110%; width: auto;"></i>
                    <h2>UPS!</h2>
                    <p style="text-transform: none!important;">Hubo un error con el método de pago, por favor pongase en contacto con su banco.</p>

                    <div class="col-12 mt-5" style="display: flex; justify-content: center;">
                        <button class="btn btn-solid" (click)="volver()">Volver</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->
<!-- Section ends -->
<!-- order-detail section start -->
<section class="section-b-space" *ngIf="!orderFail && orden">
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <div class="product-order">
                    <h3>Detalles de tu compra</h3>
                    <ng-container *ngFor="let prod of orden?.productos">
                        <div class="row product-order-detail">
                            <div class="col-3">
                                <img src="{{prod.imagen}}" alt="" class="img-fluid">
                            </div>
                            <div class="col-3 order_detail">
                                <div>
                                    <h4>Producto</h4>
                                    <h5>{{prod.nombreProducto}}</h5>
                                </div>
                            </div>
                            <div class="col-3 order_detail">
                                <div>
                                    <h4>Cantidad</h4>
                                    <h5>{{prod.cantidad}}</h5>
                                </div>
                            </div>
                            <div class="col-3 order_detail">
                                <div>
                                    <h4>precio</h4>
                                    <h5>{{prod.precio | currency:'':'symbol':'1.2-2' }}</h5>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <div class="total-sec">
                        <ul>
                            <li>Productos:<span>{{orden?.productosTotal | currency:'':'symbol':'1.2-2' }}</span></li>
                            <!-- <li>Descuento promocional:<span>{{orden?.montoDescDoropeel | currency:'':'symbol':'1.2-2' }}</span></li> -->
                            <li>Descuento por cupón:<span>{{orden?.descuento - orden?.montoDescDoropeel |
                                    currency:'':'symbol':'1.2-2' }}</span></li>
                            <li>Subtotal:<span>{{orden?.productosTotal - orden?.descuento | currency:'':'symbol':'1.2-2'
                                    }}</span></li>
                            <li>Costo por envío:
                                <span *ngIf="orden?.envio > 0; else envioGratis">{{orden?.envio |
                                    currency:'':'symbol':'1.2-2' }}</span>
                            </li>
                            <ng-template #envioGratis>
                                <span class="delivery-txt">Envío Gratis</span>
                            </ng-template>
                        </ul>
                    </div>
                    <div class="final-total">
                        <h3>total <span>{{orden?.total | currency:'':'symbol':'1.2-2' }}</span></h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="row order-success-sec">
                    <div class="col-sm-6 mb-5">
                        <h4>Información</h4>
                        <ul class="order-detail">
                            <li>Id Orden: {{orden?.idOrden}}</li>
                            <li>Fecha Orden: {{ orden.fhregistro | date:'d \'de\' MMMM \'de\' y':'':'es' | titlecase }}
                            </li>
                            <li>Orden Total: {{orden?.total | currency:'':'symbol':'1.2-2' }}</li>
                        </ul>
                    </div>
                    <div class="col-sm-6">
                        <h4>Dirección de Envío</h4>
                        <ul class="order-detail">
                            <li>{{orden?.direccion}}</li>
                        </ul>
                    </div>

                    <!-- <div class="col-sm-12 payment-mode">
                        <h4>Método de pago</h4>
                        <div style="display: flex;">
                            <img src="assets/images/icon/{{orden?.cardBrand}}.png" alt="" height="auto">
                            <h5 style="margin: 0 0 0 10px;">Que finaliza en {{orden?.last4}}</h5>
                        </div>
                    </div> -->
                    <div class="col-md-12">
                        <div class="delivery-sec">
                            <h3>Fecha aproximada de entrega</h3>
                            <h2>{{ orden?.fechaEntrega | date:'d \'de\' MMMM \'de\' y':'':'es' | titlecase }}</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 mt-5 gap-3" style="display: flex; justify-content: flex-end;"
            *ngIf="!isGuest; else GuestBtn">
            <button class="btn btn-solid" (click)="irAPedidos()">Ver mis Pedidos</button>
        </div>

        <ng-template #GuestBtn>
            <div class="col-12 mt-5 gap-3" style="display: flex; justify-content: flex-end;">
                <button class="btn btn-solid" (click)="irAComprar()">Ir a Comprar</button>
            </div>
        </ng-template>
    </div>
</section>
<!-- Section ends -->